import './App.css';
import React from "react";
import Row from "react-bootstrap/Row";
import "./Footer.css";
import celcomLogo from "./logo/celcomlogo.png";

function Footer() {
    return (
        <div className="main-footer">
            <div className="container">
                <Row className="code-row-style">
                    <img className="celcomImg" src={celcomLogo} alt="celcomLogo" style={{marginTop: '20px', marginBottom: '20px'}}/>
                </Row>
            </div>
        </div>
    );
}

export default Footer;